export function objectToQueryString(obj) {
  const str = [];
  if (!obj || typeof obj !== 'object') {
    return '';
  }
  for (const p of Object.keys(obj)) {
    if (!Object.prototype.hasOwnProperty.call(obj, p)) {
      continue;
    }
    const v = obj[p];
    if (v === undefined || v === null || v === '') {
      continue;
    }
    if (Array.isArray(v)) {
      for (const val of v) {
        if (val === undefined || val === null || val === '') {
          continue;
        }
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(val)}`);
      }
    } else {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(v)}`);
    }
  }
  return str.join('&');
}

export function parseQueryArray(params, keys = []) {
  for (const key of keys) {
    const values = params.getAll(key).filter(Boolean);
    if (values.length > 0) {
      return values;
    }
  }

  return [];
}

export function parseQueryValue(params, keys = []) {
  for (const key of keys) {
    const value = params.get(key);
    if (value) {
      return value;
    }
  }

  return '';
}
